export const POLL_FREQUENCIES = {
  DOWNLOADS: process.env.REACT_APP_POLL_FREQUENCY_DOWNLOADS || 5000,
  EDITS: process.env.REACT_APP_POLL_FREQUENCY_EDITS || 30000,
  LIBRARY_LISTING: process.env.REACT_APP_POLL_FREQUENCY_EDITS || 120000,
  PLAYLISTS: process.env.REACT_APP_POLL_FREQUENCY_PLAYLISTS || 10000,
  PRIVATE_VIDEOS: process.env.REACT_APP_POLL_FREQUENCY_PRIVATE_VIDEOS || 20000,
  UPLOADS: process.env.REACT_APP_POLL_FREQUENCY_UPLOADS || 10000,
};

export default { POLL_FREQUENCIES };
